/*
 * fn: getRecSlug
 *
 * Gets the rec slug from a rec's cardId and partnerRef
 *
 */
import { type RecType } from '@/defs/rec'
import { parseCardId } from '@/utils/cardUtil'
import { isNonEmptyString } from '@/utils/commonUtil'

type Props = Pick<RecType, 'cardId' | 'partnerRef'>

export const getRecSlug = ({ cardId, partnerRef }: Props) =>
  [parseCardId(cardId).slug, partnerRef && parseCardId(partnerRef.cardId).slug]
    .filter(isNonEmptyString)
    .map((slug) => slug.split('/')[0])
    .filter(isNonEmptyString)
    .join('-') || 'unknown-slug'
